export default __webpack_public_path__ + "static/media/landing-model.387e4f19.png";